import { render, staticRenderFns } from "./EditTutorial.vue?vue&type=template&id=1525d839&scoped=true&"
import script from "./EditTutorial.vue?vue&type=script&lang=js&"
export * from "./EditTutorial.vue?vue&type=script&lang=js&"
import style0 from "./EditTutorial.vue?vue&type=style&index=0&id=1525d839&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1525d839",
  null
  
)

export default component.exports